export const images = {
    fbIcon: require('./fb-icon.png'),
    instaIcon: require('./insta-icon.png'),
    leftArrow: require('./left-arrow.png'),
    xinchaoLogo: require('./xinchao-logo.optimized.png'),
    beefNoodle: require('./Dish_Beef_Noodle_Soup-removebg-preview.png'),
    bunchaHanoi: require('./Dish_Bun_Cha_Hanoi_Fish_Sauce-removebg-preview.png'),
    springroll: require('./Dish_Fresh_Spring_Roll-removebg-preview.png'),
    lemongrassDrink: require('./Dish_Lemongrass_Orange_Peach_Tea-removebg-preview.png'),
    horizontalBanner01:  require('./Hero_1.optimized.jpg'),
    horizontalBanner02:  require('./Hero_2.optimized.jpg'),
    verticalBanner01:  require('./VertialBanner01.optimized.png'),
    verticalBanner02:  require('./VertialBanner02.optimized.png'),
};
